export enum UserStatus {
    none = 0,
    registering = 1,
    registered = 2,
    loggedIn = 3,
    loggedOff = 4,
    timedOut = 5,
    blocked = 6,
    banned = 7,
    other = 8,
    logging = 9
}

export class UserAccessStatus {

    private status: number = UserStatus.none;

    public getUserStatus () { return this.status }

    public checkUserStatus () {
        if (this.status !== UserStatus.none) {
            const wallet        = localStorage.getItem('wallet');
            const encryptedData = localStorage.getItem('encryptedData');
            if (wallet && encryptedData) this.setUserStatus(UserStatus.timedOut);
        }
    }

    public setUserStatus (newStatus: UserStatus) {
        this.status = newStatus;
    }

}